export const STORES = {
  get: "/location/stores",
  getDetail: "/store",
  patch: "/store",
  serviceable: "/serviceable",
};
